import React, { FC, RefObject, useCallback, useEffect, useState } from 'react';
import styles from './PaymentOption.module.scss';
import { Button, Drawer, Icon, Switch } from '@mui/material';
import MoneyInput from '../partialPaymentInput/MoneyInput';
import KeyboardInput from '../../../../components/_keyboard/_KeyboardInput';
import Calculator from '../../../catalog/components/calculator/Calculator';
import SplitPaymentOrderForm from '../../../catalog/components/splitPaymentOrderForm/SplitPaymentOrderForm';
import { IExtract } from '../../../../modules/consume/domain/models/Extract';
import { useI18n } from '../../../../hooks/useI18n';
import { usePartialPaymentStore } from '../../../../modules/cart/infra/store/PartialPaymentStore';

export interface IPartilaPaymentOption {
    onFocusInput: (inputEvent: RefObject<HTMLInputElement>) => void,
    amountToPay: number,
    total: number,
    extract?: IExtract,
    onChange: (value: number) => void
    setCheckPartialPayment?: (value: boolean) => void
}

const PartialPaymentOption: FC<IPartilaPaymentOption> = ({
    onFocusInput, amountToPay, onChange, total, extract, setCheckPartialPayment
}) => {
    const { t } = useI18n();
    const [ paidAmount, amountToPayStore, setTotalStore ] = usePartialPaymentStore(state => [state.paidAmount, state.amountToPay, state.setTotal]);

    const [openCalculator, setOpenCalculator] = React.useState(false);
    const [openSpliter, setOpenSpliter] = React.useState(false);
    const [partialPaymentOpen, setPartialPayment] = useState(false);
    const [calculateResult, setCalculateResult] = useState<number>(amountToPay);

    useEffect(() => {
        if (calculateResult >= amountToPay) {
            setCalculateResult(amountToPay);
        }
        if(amountToPay <= 0){
            setCalculateResult(0);
        }
    }, [amountToPay, calculateResult])

    const onCheckPartialPayment = useCallback((_, value: boolean) => {
        setPartialPayment(value);
        setCheckPartialPayment && setCheckPartialPayment(value);
        onChange(amountToPay);

        if (!value) {
            setCalculateResult(amountToPay);
        }
    }, [setCheckPartialPayment, onChange, amountToPay]);


    const onChangePartialAmountHandle = useCallback((value: number) => {
        onChange(value);
        setCalculateResult(value);
        setOpenCalculator(false);
    }, [onChange]);

    const onClickCalculatorHandle = useCallback(() => {
        setOpenCalculator(true);
    }, []);

    const onClickSplitPaymentHandle = useCallback(() => {
        setOpenSpliter(true);
    }, []);

    const onSubmintSplitPaymentHandle = useCallback((value: number) => {
        onChangePartialAmountHandle(value);
        setOpenSpliter(false);
    }, [onChangePartialAmountHandle]);

    useEffect(() => {
        setTotalStore(total);

        if (paidAmount) {
            setCalculateResult(total - paidAmount);
            onChangePartialAmountHandle(total - paidAmount);
            setPartialPayment(true);
            setCheckPartialPayment && setCheckPartialPayment(true);
        }
    }, [onChangePartialAmountHandle, paidAmount, setCheckPartialPayment, setTotalStore, total])

    return <>
        <div className={styles.paymentOption}>
            <span>
                {t('paymentSummary.partialPayment')}
            </span>
            <Switch disabled={!extract && !!paidAmount && !!amountToPayStore} checked={partialPaymentOpen} onChange={onCheckPartialPayment} />
        </div>
        {partialPaymentOpen &&
            <div className={styles.partialPayment}>
                <MoneyInput
                    onFocus={onFocusInput}
                    defaultValue={calculateResult}
                    maxValue={amountToPay - paidAmount}
                    onChange={onChangePartialAmountHandle} />
                <Button onClick={onClickCalculatorHandle} variant="outlined" ><Icon>calculate</Icon></Button>
                {extract && <Button onClick={onClickSplitPaymentHandle} variant="outlined" ><Icon>diversity_3</Icon></Button>}
            </div>}
        <Drawer open={openCalculator} anchor='right' onClose={() => setOpenCalculator(false)}>
            <Calculator
                defaultValue={amountToPay}
                totalValue={total}
                onSubmitValue={onChangePartialAmountHandle}
                onClose={() => setOpenCalculator(false)}
            />
        </Drawer>
        {extract &&
            <Drawer open={openSpliter} anchor='right' onClose={() => setOpenSpliter(false)}>
                <SplitPaymentOrderForm maxAmoutToPay={amountToPay} onSubmit={onSubmintSplitPaymentHandle} extract={extract} onClose={() => setOpenSpliter(false)} />
            </Drawer>
        }

    </>;

};

export default PartialPaymentOption